// @flow
import React, { Component } from 'react';
import { Route } from 'react-router-dom';

import type { PageData } from './pageData';

type Props = {
  hasIdentityService: boolean,
  isFullAdmin: boolean,
  page: PageData,
};

export default class PageRoute extends Component<Props> {
  renderPage: Function;

  constructor() {
    super();
    this.renderPage = this.renderPage.bind(this);
  }

  renderPage() {
    const { isFullAdmin, hasIdentityService, page } = this.props;
    return (
      <page.component
        contents={page.contents}
        hasIdentityService={hasIdentityService}
        isFullAdmin={isFullAdmin}
        title={page.label}
        dataTestName={page.dataTestName}
      />
    );
  }

  render() {
    const { page } = this.props;
    return <Route path={page.route} render={this.renderPage} />;
  }
}



// WEBPACK FOOTER //
// ./src/view/App/PageRoute.js